import React, { Fragment, useState, useContext, useEffect } from "react";
import { Context } from "../store/AppContext";
import { useNavigate } from "react-router-dom";
import "../../styles/GeneradorDocumentos.css";
import cedula from "../../img/cedula.jpg";
import Head from "../component/Head";
import Opciones from "../component/GeneradorDocumentos/Opciones";
import Formulario from "../component/GeneradorDocumentos/Formulario";
import FormularioContabilidadPersonaNatural from "../component/GeneradorDocumentos/FormularioContabilidadPersonaNatural";
import FormularioDocumentosPatente from "../component/GeneradorDocumentos/FormularioDocumentosPatente";
import { PoderSII } from "../Helper/GeneradorDocumentos/PoderSII";
import { PoderMunicipal } from "../Helper/GeneradorDocumentos/PoderMunicipal";
import { ContratoMensualSantiago } from "../Helper/GeneradorDocumentos/ContratoMensualSantiago";
import { ContratoMensualProvidencia } from "../Helper/GeneradorDocumentos/ContratoMensualProvidencia";
import { ContratoMensualBodegaProvidencia } from "../Helper/GeneradorDocumentos/ContratoMensualBodegaProvidencia";
import { ContratoAnualSantiago } from "../Helper/GeneradorDocumentos/ContratoAnualSantiago";
import { ContratoAnualProvidencia } from "../Helper/GeneradorDocumentos/ContratoAnualProvidencia";
import { ContratoAnualBodegaProvidencia } from "../Helper/GeneradorDocumentos/ContratoAnualBodegaProvidencia";
import { Contrato30diasSantiago } from "../Helper/GeneradorDocumentos/Contrato30diasSantiago";
import { Contrato30diasProvidencia } from "../Helper/GeneradorDocumentos/Contrato30diasProvidencia";
import { Contrato30diasBodegaProvidencia } from "../Helper/GeneradorDocumentos/Contrato30diasBodegaProvidencia";
import { ContratoContabilidad } from "../Helper/GeneradorDocumentos/ContratoContabilidad";
import { ContratoContabilidadPersonaNatural } from "../Helper/GeneradorDocumentos/ContratoContabilidadPersonaNatural";
import { DocumentosPatente } from "../Helper/GeneradorDocumentos/DocumentosPatente";
import { DocumentosPatenteProvidencia } from "../Helper/GeneradorDocumentos/DocumentosPatenteProvidencia";
import { ContratoBodega } from "../Helper/GeneradorDocumentos/ContratoBodega";

const GeneradorDocumentos = () => {
	const { store, actions } = useContext(Context);
	const history = useNavigate();
	const [img, setImg] = useState(cedula);
	const [datos, setDatos] = useState({
		nombre: "",
		rut: "",
		razon: "",
		rutEmpresa: "",
		fecha: "",
		nacionalidad: "",
		planContratado: "",
		correo: "",
		telefono: "",
		tipoPersona: "Persona Jurídica",
	});
	const [datosDocumentosPatente, setDatosDocumentosPatente] = useState({
		nombre: "",
		rut: "",
		razon: "",
		rutEmpresa: "",
		actividadEspecifica: "",
		codigo1: "",
		giro1: "",
		codigo2: "",
		giro2: "",
		codigo3: "",
		giro3: "",
		numeroTrabajadoresInmueble: "1",
		numeroTrabajadoresPais: "1",
		capitalNegocio: "",
		comunaPatente: "",
	});
	const [opcion, setOpcion] = useState("Poder SII");
	const [alert, setAlert] = useState(false);
	const [animar, setAnimar] = useState(false);

	useEffect(() => {
		setTimeout(() => {
			if (store.usuarioActual == null && store.token == null) {
				history("/");
			}
		}, 200);
	});

	//Detecta unmounted
	useEffect(() => {
		setAnimar(true);
	}, []);

	/* Al hacer click en en boton de generar, se evalua si están todos los datos completos. Si ok, procede a imprimir. */
	const HandlerClick = () => {
		let fecha = new Date();
		const opciones = {
			year: "numeric",
			month: "long",
			day: "2-digit",
		};

		let JSONObject = {
			nombreRepresentante: datos.nombre,
			rutRepresentante: datos.rut,
			razon: datos.razon,
			rutEmpresa: datos.rutEmpresa,
			fecha:
				datos.fecha === "hoy"
					? fecha.toLocaleDateString("es-ES", opciones)
					: datos.fecha,
			personaGenera: store.usuarioActual,
			tipoContrato: opcion,
			tipoPersona: datos.tipoPersona || "Persona Jurídica",
		};
		const faltaEmpresa =
			datos.tipoPersona !== "Persona Natural" &&
			(datos.razon.trim() === "" || datos.rutEmpresa.trim() === "");

		if (opcion == "Documentos Patente") {
			if (
				datosDocumentosPatente.nombre.trim() === "" ||
				datosDocumentosPatente.rut.trim() === "" ||
				datosDocumentosPatente.razon.trim() === "" ||
				datosDocumentosPatente.rutEmpresa.trim() === "" ||
				datosDocumentosPatente.actividadEspecifica.trim() === "" ||
				datosDocumentosPatente.codigo1.trim() === "" ||
				datosDocumentosPatente.giro1.trim() === "" ||
				datosDocumentosPatente.numeroTrabajadoresInmueble.trim() === "" ||
				datosDocumentosPatente.numeroTrabajadoresPais.trim() === "" ||
				datosDocumentosPatente.comunaPatente.trim() === ""
			) {
				setAlert(true);
			} 
			else if (datosDocumentosPatente.comunaPatente == "Santiago" && datosDocumentosPatente.capitalNegocio.trim() === "") {
				setAlert(true);
			}
			else {
				setAlert(false);
				if (opcion == "Documentos Patente" && datosDocumentosPatente.comunaPatente == "Santiago") {
					DocumentosPatente(datosDocumentosPatente);
				} else if (opcion == "Documentos Patente" && datosDocumentosPatente.comunaPatente == "Providencia") {
					DocumentosPatenteProvidencia(datosDocumentosPatente);
				} else {
					setAlert(true);
				}
			}
		}
		if (opcion == "Contrato Contabilidad") {
			if (
				datos.nombre.trim() === "" ||
				datos.rut.trim() === "" ||
				datos.razon.trim() === "" ||
				datos.rutEmpresa.trim() === "" ||
				datos.nacionalidad.trim() === "" ||
				datos.fecha.trim() === "" ||
				datos.planContratado.trim() === ""
			) {
				setAlert(true);
			} else {
				setAlert(false);
				ContratoContabilidad(datos);
			}
		}
		if (opcion == "Conta Persona Natural") {
			if (
				datos.nombre.trim() === "" ||
				datos.rut.trim() === "" ||
				datos.nacionalidad.trim() === "" ||
				datos.fecha.trim() === "" ||
				datos.planContratado.trim() === ""
			) {
				setAlert(true);
			} else {
				setAlert(false);
				ContratoContabilidadPersonaNatural(datos);
			}
		}
		if (opcion == "Poder SII" || opcion == "Poder Municipal") {
			if (
				datos.nombre.trim() === "" ||
				datos.rut.trim() === "" ||
				datos.razon.trim() === "" ||
				datos.rutEmpresa.trim() === "" ||
				datos.nacionalidad.trim() === "" ||
				datos.fecha.trim() === ""
			) {
				setAlert(true);
			} else {
				setAlert(false);
				if (opcion == "Poder SII" && img != cedula) {
					PoderSII(datos, img);
				} else if (opcion == "Poder Municipal" && img != cedula) {
					PoderMunicipal(datos, img);
				} else {
					setAlert(true);
				}
			}
		}
		if (
			opcion == "Contrato Arriendo Mensual" ||
			opcion == "Contrato Arriendo Anual" ||
			opcion == "Contrato Arriendo 30 dias"
		) {
			if (
				datos.nombre.trim() === "" ||
				datos.rut.trim() === "" ||
				faltaEmpresa ||
				datos.nacionalidad.trim() === "" ||
				datos.fecha.trim() === "" ||
				datos.correo.trim() === "" ||
				datos.telefono.trim() === "" ||
				datos.oficina.trim() === ""
			) {
				setAlert(true);
			} else {
				setAlert(false);
				if (opcion == "Contrato Arriendo Mensual" && img != cedula) {
					if (datos.oficina == "Santiago Centro") {
						ContratoMensualSantiago(datos, img);
						fetch("https://hooks.zapier.com/hooks/catch/2499772/3r1swrr/", {
							method: "POST",
							body: JSON.stringify(JSONObject),
						});
					} else if (datos.oficina == "Providencia") {
						ContratoMensualProvidencia(datos, img);
						fetch("https://hooks.zapier.com/hooks/catch/2499772/3r1swrr/", {
							method: "POST",
							body: JSON.stringify(JSONObject),
						});
					} else if (datos.oficina == "Bodega Providencia") {
						ContratoMensualBodegaProvidencia(datos, img);
						fetch("https://hooks.zapier.com/hooks/catch/2499772/3r1swrr/", {
							method: "POST",
							body: JSON.stringify(JSONObject),
						});
					} else {
						setAlert(true);
					}
				} else if (opcion == "Contrato Arriendo Anual" && img != cedula) {
					if (datos.oficina == "Santiago Centro") {
						ContratoAnualSantiago(datos, img);
						fetch("https://hooks.zapier.com/hooks/catch/2499772/3r1swrr/", {
							method: "POST",
							body: JSON.stringify(JSONObject),
						});
					} else if (datos.oficina == "Providencia") {
						ContratoAnualProvidencia(datos, img);
						fetch("https://hooks.zapier.com/hooks/catch/2499772/3r1swrr/", {
							method: "POST",
							body: JSON.stringify(JSONObject),
						});
					} else if (datos.oficina == "Bodega Providencia") {
						ContratoAnualBodegaProvidencia(datos, img);
						fetch("https://hooks.zapier.com/hooks/catch/2499772/3r1swrr/", {
							method: "POST",
							body: JSON.stringify(JSONObject),
						});
					} else {
						setAlert(true);
					}
				} else if (opcion == "Contrato Arriendo 30 dias" && img != cedula) {
					if (datos.oficina == "Santiago Centro") {
						Contrato30diasSantiago(datos, img);
						fetch("https://hooks.zapier.com/hooks/catch/2499772/3r1swrr/", {
							method: "POST",
							body: JSON.stringify(JSONObject),
						});
					} else if (datos.oficina == "Providencia") {
						Contrato30diasProvidencia(datos, img);
						fetch("https://hooks.zapier.com/hooks/catch/2499772/3r1swrr/", {
							method: "POST",
							body: JSON.stringify(JSONObject),
						});
					} else if (datos.oficina == "Bodega Providencia") {
						Contrato30diasBodegaProvidencia(datos, img);
						fetch("https://hooks.zapier.com/hooks/catch/2499772/3r1swrr/", {
							method: "POST",
							body: JSON.stringify(JSONObject),
						});
					} else {
						setAlert(true);
					}
				} else {
					setAlert(true);
				}
			}
		}
		if (opcion == "Contrato Bodega") {
			if (
				datos.nombre.trim() === "" ||
				datos.rut.trim() === "" ||
				faltaEmpresa ||
				datos.nacionalidad.trim() === "" ||
				datos.fecha.trim() === ""
			) {
				setAlert(true);
			} else {
				setAlert(false);
				ContratoBodega(datos, img);
			}
		}
	};

	const HandlerReset = () => {
		setDatos({
			nombre: "",
			rut: "",
			razon: "",
			rutEmpresa: "",
			fecha: "",
			nacionalidad: "",
			planContratado: "",
			correo: "",
			telefono: "",
			tipoPersona: "Persona Jurídica",
		});
		setDatosDocumentosPatente({
			nombre: "",
			rut: "",
			razon: "",
			rutEmpresa: "",
			codigo1: "",
			giro1: "",
			codigo2: "",
			giro2: "",
			codigo3: "",
			giro3: "",
			numeroTrabajadoresInmueble: "1",
			numeroTrabajadoresPais: "1",
			capitalNegocio: "",
		});
		setImg(cedula);
	};

	const titulosHead = [
		"Generador de Documentos",
		"Elige una opción, y genera tus documentos.",
	];

	return (
		<Fragment>
			<Head contenido={titulosHead} />
			<div className={`divGenerador ${animar && "animar"}`}>
				<Opciones opcion={opcion} setOpcion={setOpcion} />
				<hr />
				{alert ? (
					<div className='callout alert text-center'>
						Todos los Datos son Necesarios
					</div>
				) : null}
				{opcion == "Documentos Patente" && (
					<FormularioDocumentosPatente
						datosDocumentosPatente={datosDocumentosPatente}
						setDatosDocumentosPatente={setDatosDocumentosPatente}
					/>
				)}
				{opcion == "Conta Persona Natural" && (
					<FormularioContabilidadPersonaNatural
						img={img}
						setImg={setImg}
						datos={datos}
						setDatos={setDatos}
						opcion={opcion}
					/>
				)}
				{opcion != "Documentos Patente" &&
					opcion != "Conta Persona Natural" && (
						<Formulario
							img={img}
							setImg={setImg}
							datos={datos}
							setDatos={setDatos}
							opcion={opcion}
						/>
					)}
				<div className='row'>
					{alert ? (
						<div className='columns small-12'>
							<div className='callout alert text-center'>
								Todos los Datos son Necesarios
							</div>
						</div>
					) : null}
					<div className='columns small-6'>
						<button
							className='button expanded'
							style={{ borderRadius: "10px" }}
							onClick={(e) => HandlerClick(e)}
						>
							Generar {opcion}
						</button>
					</div>
					<div className='columns small-6'>
						<button className='alert button' onClick={(e) => HandlerReset(e)} style={{ borderRadius: "10px" }}>
							Reset
						</button>
					</div>
				</div>
			</div>
		</Fragment>
	);
};

export default GeneradorDocumentos;
